module.exports = __webpack_public_path__ + "static/media/detail15.9bd2b262.jpg";